module.exports = __webpack_public_path__ + "static/media/s_bar15.c7976fce.svg";